export const isOwnGroup = ({ group, expertId }) => {
  return group?.expert?.id === expertId;
};
